import { readonly, ref } from 'vue'

/**
 * Increments after every successful mutating API call.
 *
 * Navigation gates and milestones are derived from the tenant's documents, so a
 * write anywhere in the app can open a gate. Keeping the counter here - rather
 * than publishing it from the milestones store - lets the axios layer announce
 * writes without importing the store, which would cycle back through the
 * services that use `api`.
 */
const revision = ref(0)

function markTenantDataChanged(): void {
  revision.value += 1
}

/**
 * Singleton for use outside Vue components (e.g. api.ts).
 */
export const tenantDataState = {
  markChanged: markTenantDataChanged,
}

/**
 * Composable for stores that refetch tenant-derived state after a write.
 */
export function useTenantDataRevision() {
  return {
    revision: readonly(revision),
  }
}
